import { render } from "./ApplicationPermissionsRow.vue?vue&type=template&id=76e106f0&scoped=true"
import script from "./ApplicationPermissionsRow.vue?vue&type=script&lang=js"
export * from "./ApplicationPermissionsRow.vue?vue&type=script&lang=js"

import "./ApplicationPermissionsRow.vue?vue&type=style&index=0&id=76e106f0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e106f0"]])

export default __exports__